import { RouteObject } from 'react-router-dom';
import ForgotPassword from '@/views/pages/auth/forgot-password';
import Login from '@/views/pages/auth/login';
import SetNewPassword from '@/views/pages/auth/set-new-password';
import GuestGuard from '@/router/guards/GuestGuard';

const routes: RouteObject[] = [
	{
		path: '/auth/login',
		element: <GuestGuard element={<Login />} />,
	},
	{
		path: '/auth/forgot-password',
		element: <GuestGuard element={<ForgotPassword />} />,
	},
	{
		path: '/auth/set-new-password',
		element: <GuestGuard forceLogout element={<SetNewPassword />} />,
	},
];

export default routes;
